import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useStoreCategory, StoreCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<StoreCategory>
    useData={useStoreCategory}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
